import { render, staticRenderFns } from "./MensajeInicial.vue?vue&type=template&id=6ec0400c&"
import script from "./MensajeInicial.vue?vue&type=script&lang=js&"
export * from "./MensajeInicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports